require('./insurancesListCardBodyItem.scss');
require('./insurancesListCardBodyItem.override.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { Link } = require('react-router-dom');
const Immutable = require('immutable');

// @ core
const { getLanguage } = require('core/i18n').i18n;

// @ components
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');


// @ helpers
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { FormattedText } = require('core/i18n').i18n;

const InsurancesListCardBodyItem = props => {
    const { amount, currency, subtitle, link, mortgage, title } = props;

    const amountObject = Immutable.fromJS({
        amount,
        currency
    });

    const plainAmountObject = getPlainAmountObject(amountObject);

    function getMortgageInfo(mortgage) {
        if(mortgage) {
            const infoRow = `${mortgage.description} ${mortgage.title}`;
            return (
                <div className="row">
                    <div className="col-xs-12 col-sm-6 insurances-list-card-item__content">
                        {infoRow}
                        <Link to={mortgage.link} className="insurances-list-card-item__link">
                            <FormattedText
                                className="insurances-list-card-item__link-text"
                                value="insuranceLanding-mortgageLinkInsurance"
                            />
                        </Link>
                    </div>
                </div>
            )
        }
    }

    return (
        <div className="insurances-list-card-item">
            <div className="row">
                <div className="col-xs-12 col-sm-6">
                    <Link to={link} className="insurances-list-card-item__title">
                        {title}
                    </Link>
                </div>
                <div className="col-xs-12 col-sm-4">
                    {subtitle}
                </div>
                <div className="col-xs-12 col-sm-2">
                    <div className="insurances-list-card-item__amount-object">
                        <span className="insurances-list-card-item__amount">
                            <OneLineSymbolAmount
                                amountObject={plainAmountObject}
                                language={getLanguage()}
                                amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                        </span>
                    </div>
                </div>
            </div>
            {getMortgageInfo(mortgage)}
        </div>
    );
};

InsurancesListCardBodyItem.propTypes = {
    amount: PropTypes.number,
    currency: PropTypes.string,
    link: PropTypes.string,
    mortgage: PropTypes.object,
    title: PropTypes.string,
    subtitle: PropTypes.string
};

module.exports = InsurancesListCardBodyItem;
